import React, { useState, useMemo, useCallback, useEffect, useRef, memo } from 'react';
import { SessionManager } from './SessionManager.js';

const SHARED_STYLES = {
  sessionBadge: { background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 8, padding: '4px 10px', fontSize: 11, color: '#475569', cursor: 'pointer', fontWeight: 600 },
  sessionDropdown: { position: 'absolute', top: '100%', right: 0, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: 10, minWidth: 200, boxShadow: '0 4px 12px rgba(0,0,0,.1)', zIndex: 100 },
};

// ── LOADING SPINNER ──────────────────────────────────────────────────────────
const PortalLoader = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 32, fontWeight: 900, color: '#0f172a', letterSpacing: 2, marginBottom: 8 }}>SYKES</div>
      <div style={{ fontSize: 13, color: '#64748b' }}>Loading portal...</div>
    </div>
  </div>
);


// ── ACTIVE SESSIONS DISPLAY COMPONENT ────────────────────────────────────────
const ActiveSessionsBadge = React.memo(function ActiveSessionsBadge({ portal }) {
  const [sessions, setSessions] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    let mounted = true;
    const poll = async () => {
      const active = await SessionManager.getActiveSessions(portal);
      if (mounted) setSessions(active);
    };
    poll();
    const interval = setInterval(poll, 30000);
    return () => { mounted = false; clearInterval(interval); };
  }, [portal]);
  const deviceId = SessionManager.getDeviceId();
  const others = sessions.filter(s => s.deviceId !== deviceId);
  if (others.length === 0) return null;
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button onClick={() => setShow(!show)} style={SHARED_STYLES.sessionBadge}>
        🖥 {sessions.length} device{sessions.length !== 1 ? 's' : ''} active
      </button>
      {show && <div style={SHARED_STYLES.sessionDropdown}>
        <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 6, color: '#475569' }}>Active Sessions</div>
        {sessions.map(s => (
          <div key={s.id} style={{ fontSize: 11, padding: '4px 0', borderBottom: '1px solid #f1f5f9', color: s.deviceId === deviceId ? '#059669' : '#64748b' }}>
            {s.deviceId === deviceId ? '● This device' : '○ ' + (s.isMobile ? 'Mobile' : 'Desktop')}
            <span style={{ marginLeft: 8, fontSize: 10, color: '#94a3b8' }}>{new Date(s.lastActivity).toLocaleTimeString()}</span>
          </div>
        ))}
      </div>}
    </div>
  );
});

// ── MEMOISED TABLE ROW COMPONENT ─────────────────────────────────────────────
const EditableRow = React.memo(function EditableRow({ item, columns, onUpdate, rowStyle }) {
  return (
    <tr style={rowStyle}>
      {columns.map(col => (
        <td key={col.key} style={col.tdStyle}>
          {col.render ? col.render(item, (field, value) => onUpdate(field, value)) :
            <input value={item[col.key] || ''} onChange={e => onUpdate(col.key, e.target.value)}
              type={col.type || 'text'} style={col.inputStyle} placeholder={col.placeholder} />}
        </td>
      ))}
    </tr>
  );
});


export { PortalLoader, ActiveSessionsBadge, EditableRow };
